import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";

import { Auth } from "../../services/Authentication";
import { Firebase } from "src/services/Firebase";
import { FirebaseError } from "firebase/app";
import { getStockDraftKey } from "src/utils/idempotency";

const authService = new Auth();
const firebaseService = new Firebase();

const REDUCER_MODULE_NAME = "AUTH";

const initialState = {
  loading: false,
  user: {},
  firebase_user: {},
  permissions: [],
  message: "",
  formIsReady: false,
  error: "",
};

export const login = createAsyncThunk(
  `${REDUCER_MODULE_NAME}/login`,
  async ({ email, password }, { rejectWithValue }) => {
    try {
      await firebaseService.login(email, password);

      const { data } = await authService.login({ email, password });
      const { claims } = jwtDecode(data.token);

      localStorage.setItem("user", JSON.stringify({ token: data.token }));

      return {
        user: { ...claims },
        permissions: [...data.permissions],
        message:
          "Inicio de sesión exitoso, será redirigido al inicio del sistema.",
      };
    } catch (error) {
      console.error("ERROR EN LOGIN:", error);
      let errorMessage = error.response?.data?.message || error.message;

      if (error instanceof FirebaseError) {
        if (error.code === "auth/wrong-password") {
          errorMessage = "Usuario o contraseña incorrectos.";
        }
      }

      return rejectWithValue(errorMessage);
    }
  },
);

export const logoutThunk = () => async (dispatch) => {
  await firebaseService.logout();
  localStorage.removeItem(getStockDraftKey());
  localStorage.removeItem("user");
  localStorage.removeItem("persist:smart360");
  dispatch(logout());
};

export const authSlice = createSlice({
  name: REDUCER_MODULE_NAME,
  initialState,
  reducers: {
    setFirebaseUser(state, action) {
      state.firebase_user = action.payload;
    },
    clearAfterLogin(state) {
      state.message = "";
      state.error = "";
      state.formIsReady = false;
      state.loading = false;
    },
    logout: () => initialState,
    setSessionPermissions(state, action) {
      state.permissions = action.payload.permissions;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.permissions = action.payload.permissions;
        state.message = action.payload.message;
        state.formIsReady = true;
      })

      // Global Matchers for consistency
      .addMatcher(isAnyOf(login.pending), (state) => {
        state.loading = true;
        state.error = "";
        state.formIsReady = false;
      })
      .addMatcher(isAnyOf(login.fulfilled), (state) => {
        state.loading = false;
      })
      .addMatcher(isAnyOf(login.rejected), (state, action) => {
        state.loading = false;
        state.user = {};
        state.permissions = [];
        state.message = "";
        state.error = action.payload || "Error desconocido";
      });
  },
});

export const { logout, clearAfterLogin, setFirebaseUser, setSessionPermissions } = authSlice.actions;

export default authSlice.reducer;
